module.exports = __webpack_public_path__ + "static/media/business_conference__monochromatic.589f54c7.svg";